import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Icon from '/@/components/icon';
import styles from './styles.module.css';

const icons = [
    'soy',
    'corn',
    'weeds',
    'pest',
    'disease',
    'rain',
    'register',
    'whatsapp',
    'density',
    'refuge',
    'plagues',
    'phenology',
    'fertilization',
    'cycle',
    'features',
    'plantingDates',
];

@autobind
export default class CircleIcon extends Component {
    static propTypes = {
        icon: PropTypes.oneOf(icons).isRequired,
        size: PropTypes.oneOf(['sm', 'md']).isRequired,
        color: PropTypes.string.isRequired,
    };

    render() {
        return (
            <div
                className={classNames(
                    styles.root,
                    styles[this.props.size],
                    styles[this.getTheme()],
                    this.props.className
                )}
            >
                <Icon type={this.props.icon} />
            </div>
        );
    }
}
